import React, { useState } from "react";

function Navigation() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-sm">
      <div className="max-w-7xl mx-auto px-8 md:px-16 lg:px-24">
        <div className="flex items-center justify-between h-16">
          {/* Navigation Links */}
          <div className="hidden md:flex items-center gap-8">
            <a href="#about" className="text-primary hover:text-secondary transition-colors focus-visible-ring rounded-md px-2 py-1">
              About
            </a>
            <a href="#work" className="text-primary hover:text-secondary transition-colors focus-visible-ring rounded-md px-2 py-1">
              Work
            </a>
            <a href="#contact" className="text-primary hover:text-secondary transition-colors focus-visible-ring rounded-md px-2 py-1">
              Contact
            </a>
          </div>
          
          {/* Book a Call Button */}
          <a 
            href="#contact" 
            className="hidden md:block px-6 py-2 bg-primary text-white rounded-full hover:bg-gray-800 transition-colors ml-auto focus-visible-ring"
          >
            Book a Call
          </a>
          
          {/* Mobile Menu Button */}
          <button 
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden absolute right-8 top-1/2 -translate-y-1/2 text-primary focus-visible-ring rounded-md p-2"
            aria-label="Toggle mobile menu"
            aria-expanded={isMenuOpen}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {isMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200">
          <div className="px-8 py-4 space-y-3">
            <a 
              href="#about" 
              onClick={() => setIsMenuOpen(false)}
              className="block text-primary hover:text-secondary transition-colors"
            >
              About
            </a>
            <a 
              href="#work" 
              onClick={() => setIsMenuOpen(false)}
              className="block text-primary hover:text-secondary transition-colors"
            >
              Work
            </a>
            <a 
              href="#contact" 
              onClick={() => setIsMenuOpen(false)}
              className="block text-primary hover:text-secondary transition-colors"
            >
              Contact
            </a>
            <a 
              href="#contact" 
              onClick={() => setIsMenuOpen(false)}
              className="block px-6 py-2 bg-primary text-white rounded-full hover:bg-gray-800 transition-colors text-center"
            >
              Book a Call
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}

export default Navigation;